import { render, staticRenderFns } from "./DrugForm.vue?vue&type=template&id=04cbe4ce&lang=pug"
import script from "./DrugForm.vue?vue&type=script&lang=js"
export * from "./DrugForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports